<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <!-- USER DETAIL -->
    <userDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></userDetail>

    <!-- USER EDIT/CREATE FORM -->
    <userForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></userForm>
  </Drawer>
</template>

<script>
import { BaseItemData } from "../../base/base_item.js";
import userForm from "@/apps/user/userForm.vue";
import userDetail from "@/apps/user/userDetail.vue";

let _app = BaseItemData();
_app.components = {
  userForm,
  userDetail
};

_app.data = function() {
  return {
    titles: {
      detail: "Пользователь",
      edit: "Редактирование пользователя",
      create: "Создание пользователя"
    },
    itemAction: "detail",
    itemId: "",
    showDrawer: false
  };
};
export default _app;
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/user/userItem.vue